export default function addQueryString(url: string, queryString: string) {
  const hasQuery = url.includes('?');
  const separator = hasQuery ? '&' : '?';
  const hasTrailingSlash = url.endsWith('/');

  return queryString === ''
    ? url
    : `${url}${!hasQuery && !hasTrailingSlash ? '/' : ''}${separator}${queryString}`;
}
